import * as Helpers from "./helpers";

import { Parameters } from "./parameters";

import { PlotterCanvas2D } from "./plotter/plotter-canvas-2d";

import { ThreadComputer } from "./threading/thread-computer";
import { ThreadPlotter } from "./threading/thread-plotter";

import "./page-interface-generated";

function main(): void {
    const MAX_COMPUTING_TIME_PER_FRAME = 50; // ms
    const canvasPlotter = new PlotterCanvas2D();
    let threadPlotter: ThreadPlotter = null;
    let threadComputer: ThreadComputer = null;
    let needToReset = true;

    Parameters.addRedrawObserver(() => { threadPlotter?.reset(); });
    Parameters.addResetObserver(() => { needToReset = true; });

    function mainLoop(): void {
        if (needToReset) {
            threadComputer.reset(Parameters.linesOpacity, Parameters.linesThickness);
            threadPlotter.reset();
            needToReset = false;
        }

        const computedSomething = threadComputer.computeNextSegments(MAX_COMPUTING_TIME_PER_FRAME);

        if (computedSomething && Parameters.showIndicators) {
            threadComputer.updateIndicators(Page.Canvas.setIndicatorText);
        }

        threadPlotter.plot();

        if (Parameters.debug) {
            threadComputer.drawDebugView(canvasPlotter.context);
        }

        requestAnimationFrame(mainLoop);
    }

    function updateBlur(blur: number): void {
        canvasPlotter.blur = blur;
    }
    Parameters.addBlurChangeObserver(updateBlur);
    updateBlur(Parameters.blur);

    function onNewImage(image: HTMLImageElement): void {
        Page.Canvas.showLoader(false);
        threadComputer = new ThreadComputer(image);
        threadPlotter = new ThreadPlotter(canvasPlotter, threadComputer);
        needToReset = true;

        (window as any).threadPlotter = threadPlotter;
    }
    Parameters.addFileUploadObserver(onNewImage);

    Page.Canvas.showLoader(true);
    const defaultImage = new Image();
    defaultImage.addEventListener("load", () => {
        onNewImage(defaultImage);
        requestAnimationFrame(mainLoop);
    });
    defaultImage.src = "./resources/cat.jpg";
    Page.Canvas.getCanvas().style.transform = 'scale(-1, 1)';

    Parameters.addDownloadInstructionsObserver(() => {
        const text = threadComputer.instructions;
        const filename = "PRINT.txt";
        Helpers.downloadTextFile(text, filename);
    });
    Parameters.addCopyInstructionsObserver(() => {
        const text = threadComputer.instructions;
        
        (async ()=>{
            try{
                navigator.clipboard.writeText(text);
            }
            catch(error) {}
        })();
    });

    document.querySelector('footer')?.remove();
    document.querySelector('header')?.remove();
    document.querySelector('.intro')?.remove();
}

Helpers.declarePolyfills();
main();

(window as any).drawPoints = (points: number[]) => {
    (window as any).threadPlotter.plotter.resize();
    (window as any).threadPlotter.plotter.initialize({ backgroundColor: 'white', blur: 0 });
    (window as any).threadPlotter.threadComputer.drawPegs((window as any).threadPlotter.plotter);

    const transformation = (window as any).threadPlotter.threadComputer.computeTransformation((window as any).threadPlotter.plotter.size);

    (window as any).threadPlotter.plotter.drawBrokenLine(points.map(e => transformation.transform((window as any).threadPlotter.threadComputer.pegs[(e + 150) % (window as any).threadPlotter.threadComputer.pegs.length])), 0, 0.2, 0, 2.56);
}